import type { CampaignDto } from "src/app/features/Campaign/types/CampaignDto";
import type { CampaignEntity, CampaignTerminalsTableEntity } from "src/app/features/Campaign/types/CampaignEntity";

export const CampaignDtoToEntity = ({ ...rest }: Readonly<CampaignDto>): CampaignEntity => {
    const mapTerminalsToCampaignTerminalsTableType = (terminals?: string[], sites?: string[]): CampaignTerminalsTableEntity | undefined => {
        const areAllTerminalsSelected = sites && sites.length > 0 && (!terminals || terminals.length === 0);
        const terminalIdList = terminals ?? undefined;

        return { areAllTerminalsSelected, terminalIdList };
    };

    const mapTerminalsToTextarea = (terminals?: string[]): string | undefined =>
        terminals && terminals.length > 0 ? terminals.join("\n") : undefined;

    return {
        ...rest,
        oldSites1: rest.sites1,
        oldSites2: rest.sites2,
        terminals1: mapTerminalsToCampaignTerminalsTableType(rest.terminals1, rest.sites1),
        terminals2: mapTerminalsToCampaignTerminalsTableType(rest.terminals2, rest.sites2),
        textareaTerminalsInput1: mapTerminalsToTextarea(rest.terminals1),
        textareaTerminalsInput2: mapTerminalsToTextarea(rest.terminals2),
    };
};
